import { render, staticRenderFns } from "./EvaThankyou.vue?vue&type=template&id=2b3dc9cb&scoped=true&"
import script from "./EvaThankyou.vue?vue&type=script&lang=js&"
export * from "./EvaThankyou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3dc9cb",
  null
  
)

component.options.__file = "EvaThankyou.vue"
export default component.exports